export default "__VITE_ASSET__sYEDWywH__"